(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SmsLimitDetailController', SmsLimitDetailController);

    SmsLimitDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SmsLimit'];

    function SmsLimitDetailController($scope, $rootScope, $stateParams, previousState, entity, SmsLimit) {
        var vm = this;

        vm.smsLimit = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:smsLimitUpdate', function(event, result) {
            vm.smsLimit = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
